<template>
    <div class="pagination flex ">
      <button  @click="goToPage(page - 1)"  :disabled="page === 1" class="px-2 py-1 bg-neutral-200 text-neutral-600 rounded disabled:bg-gray-300">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
      </button>
  
      <span v-for="pageNumber in paginationRange" :key="pageNumber">
        <button
          v-if="pageNumber !== '...'"
          @click="goToPage(pageNumber)"
          :class="{'bg-blue-500 text-white': page === pageNumber, 'bg-neutral-200 text-neutral-600': page !== pageNumber}"
          class="mx-1 px-3 py-1 text-sm font-medium rounded">
          {{ pageNumber }}
        </button>
        <span v-else class="mx-1">...</span>
      </span>
  
      <button @click="goToPage(page + 1)" :disabled="page === totalPages" class="px-2 py-1 bg-neutral-200 text-neutral-600 rounded disabled:bg-gray-300">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor" class="size-3">
            <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
        </svg>
      </button>
    </div>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },
  computed: {
    paginationRange() {
      const range = [];
      const totalShownPages = 3;
      const sidePages = 1;

      if (this.totalPages <= totalShownPages) {
        for (let i = 1; i <= this.totalPages; i++) {
          range.push(i);
        }
      } else {
        // Always show the first page
        range.push(1);

        if (this.page > sidePages + 2) {
          range.push('...');
        }

        // Pages around the current page
        const start = Math.max(2, this.page - sidePages);
        const end = Math.min(this.totalPages - 1, this.page + sidePages);
        for (let i = start; i <= end; i++) {
          range.push(i);
        }

        if (this.page < this.totalPages - sidePages - 1) {
          range.push('...');
        }

        // Always show the last page
        range.push(this.totalPages);
      }

      return range;
    }
  },
  methods: {
    goToPage(newPage) {
      if (newPage >= 1 && newPage <= this.totalPages && newPage !== this.page) {
        this.$emit('page-change', newPage);
      }
    }
  }
};
</script>
  

  